import React, { useEffect } from "react";
import { FButton, FItem } from "ferrum-design-system";
import { Link } from "react-router-dom";
import { PATH_DASHBOARD } from "../../routes/paths";
import DashboardIcon from "../../assets/ms-new-images/icons/dashboard-icon.svg";
import SwapIcon from "../../assets/ms-new-images/icons/swap-icon.svg";
import WalletIcon from "../../assets/ms-new-images/icons/wallet-icon.svg";
import MyTradesIcon from "../../assets/ms-new-images/icons/trades-icon.svg";
import { ConnectedWalletAccount } from "../../utils/connect-wallet/ConnectedWalletAccount";
import { WalletConnector } from "foundry";

const DashboardFooter = () => {
  const multiswap =
    window.location.pathname.includes("swap") ||
    window.location.pathname.includes("my-trades");
  // window.location.pathname.includes("dashboard/profile");
  const leaderboard = window.location.pathname.includes(
    "pub/staking/leaderboard"
  );

  return (
    <>
      {multiswap || leaderboard ? (
        <FItem className="navbar navbar-mobile">
          <Link to={PATH_DASHBOARD.multiswap.swap} className="">
            <div className="text-center">
              <img src={DashboardIcon} height={24} width={24} />
            </div>
            <span>Dashboard</span>
          </Link>
          <Link to={"#"} className="">
            <WalletConnector
              WalletConnectView={FButton}
              WalletConnectModal={ConnectedWalletAccount}
              WalletConnectViewProps={{
                title: (
                  <img
                    src={WalletIcon}
                    height={24}
                    width={24}
                    className="text-center"
                  />
                ),
                className: "bg-transparent no-border-color all-unset",
              }}
            />
            <span>Wallet</span>
          </Link>
          <Link to={PATH_DASHBOARD.multiswap.swap} className="">
            <div className="text-center">
              <img src={SwapIcon} height={24} width={24} />
            </div>
            <span>Swap</span>
          </Link>
          <Link to={PATH_DASHBOARD.multiswap.myTrades} className="">
            <div className="text-center">
              <img src={MyTradesIcon} height={24} width={24} />
            </div>
            <span>My Trades</span>
          </Link>
        </FItem>
      ) : null}
    </>
  );
};

export default DashboardFooter;
